import { Directive, ElementRef } from '@angular/core';
import { input, effect} from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { LandBotService } from 'src/app/land-bot.service';

/** 
 *  S'afegeix, dins el ion-buttons d'un ion-toolbar al ion-header, a un ion-button amb la icona 
 * 'helpCircleOutline', i es pot deshabilitar (hidden) a conveniència:
 * 
 * <ion-button appLandBot [hidden]="!detail().isPRL || view!='admin'">
 *  <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
 * </ion-button>
 * 
 */

@Directive({
  selector: '[appLandBot]',
  host: { '(click)': 'onClick()' },
  standalone: true,
})
export class LandBotDirective {

  hidden = input<boolean>(false);
  private _enabled = !Capacitor.isNativePlatform();

  constructor(
    private botService: LandBotService,
    private elem: ElementRef<HTMLElement>,
  ) {
    effect(()=>{
      this._enabled = !this.hidden() && !Capacitor.isNativePlatform();
      if (this._enabled) this.elem.nativeElement.classList.remove('ion-hide');
      else this.elem.nativeElement.classList.add('ion-hide');
    });
    if (!this._enabled) this.elem.nativeElement.classList.add('ion-hide');
  }

  onClick() {
    if (!this._enabled) return;
    this.botService.openBot();
  }

}
